export default () => {
  let $ = jQuery

  $('.cards-loader').hide()

  if ($('.category-tabs .tab').length >= 6) {
    $('.category-tabs').css({
      display: '-webkit-box',
      '-webkit-box-orient': 'horizontal',
      'flex-wrap': 'nowrap',
      'overflow-x': 'scroll',
    })
  }

  const blogTabs = document.querySelectorAll('.category-tabs .tab')
  if (!blogTabs.length) return

  Array.from(blogTabs).forEach(function (blogTab) {
    blogTab.addEventListener('click', function () {
      hideAllContents()
      blogTab.classList.add('active')
      return
    })
  })

  function hideAllContents() {
    Array.from(blogTabs).forEach(function (blogTab) {
      blogTab.classList.remove('active')
    })
  }

  $('.category-tabs .tab').click(function () {
    let categoryId = $(this).data('category')
    let postsPerPage = $('.category-tabs').data('posts-per-page')

    $('.blog-main').hide()
    $('.blog-recommended').hide()
    $('.hero').hide()
    $('.blog-share').hide()
    $('.blog-content').hide()

    $.ajax({
      url: window.ajax_.ajax_url,
      type: 'get',
      data: {
        action: 'postsByCategory',
        category_id: Number(categoryId),
        posts_per_page: Number(postsPerPage),
      },
      beforeSend: function () {
        $('.cards-loader').show()

        $('.cards-tab-contents').html('')
      },
      success: function (response) {
        $('.cards-loader').hide()

        setTimeout(function () {
          $('.cards-tab-contents')
            .html(response.data.html)
            .show()
            .fadeIn('slow')
        }, 500)
      },
    })
  })
}
